import { ReactNode } from 'react'

import { AppFooter } from 'components/layout/AppFooter'
import Loader from 'components/layout/Loader'
import { IconLogo } from 'utils/constants/images'

import 'scss/layouts/_form-layout.scss'

interface IFormLayout {
  children: ReactNode
}

const FormLayout = ({ children }: IFormLayout) => (
  <div className="w-100 h-100 bg-F1F9F8">
    <Loader />
    <div className="d-flex flex-column bg-F1F9F8">
      <div className="w-100 d-flex flex-column justify-content-center align-items-center bases__gap20 flex-grow-1 bases__margin--top60">
        <IconLogo className="w-280 bases__height60px" />
        {children}
      </div>
      <AppFooter />
    </div>
  </div>
)

export default FormLayout
